import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Text, Paper, Stack, Title } from '@mantine/core';
import { Home } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '100dvh',
        backgroundColor: 'var(--global-gray-lighter-7)',
        padding: '2rem',
      }}
    >
      <Paper
        style={{
          width: 'min(400px, 90vw)',
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
          border: '1px solid #f0f0f0',
        }}
      >
        <Stack gap="lg">
          <div style={{ textAlign: 'center' }}>
            <Title order={1} style={{ fontFamily: 'Lato', color: '#333', marginBottom: '0.5rem', fontSize: '4rem' }}>
              404
            </Title>
            <Title order={2} style={{ fontFamily: 'Lato', color: '#333', marginBottom: '0.5rem' }}>
              Page Not Found
            </Title>
            <Text size="sm" style={{ fontFamily: 'Lato', color: '#666' }}>
              The page you're looking for doesn't exist.
            </Text>
          </div>

          <Button
            onClick={() => navigate('/feed')}
            leftSection={<Home size={16} />}
            size="md"
            style={{
              backgroundColor: 'var(--global-main)',
              fontFamily: 'Lato',
              fontWeight: '600',
              borderRadius: '8px',
            }}
            fullWidth
          >
            Go Home
          </Button>
        </Stack>
      </Paper>
    </div>
  );
}
